import styles from './Dashboard.module.css';
import '../../resources/css/admin_style.css';
import { AuthContext } from '../../utils/contextapi/AuthProvider';
import React, {useEffect, useRef, useState, useContext} from "react";
import {IAM_SERVER_DASHBOARD, USER_SERVER_DASHBOARD_CHART, USER_SERVER_IDENTITY} from "../../utils/Config";
import axios from "../../utils/api/axios";
import {CircularProgress} from "@mui/material";
import {Doughnut, Line} from "react-chartjs-2";
import Chart from 'chart.js/auto'; //지우면 안됨 category 에러
import { useServiceList } from '../../utils/service/serviceList';
import { useSelectedService } from '../../utils/contextapi/ServiceProvider';
import { StatCard } from './component/statCard/StatCard';

/**
 * 시간 인터벌 메서드
 * @param callback
 * @param delay
 */
function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            const intervalId = setInterval(tick, delay);
            return () => clearInterval(intervalId);
        }
    }, [delay]);
}


/**
 * 대시보드 화면
 * @param callback
 * @param delay
 */
function Dashboard({setMovePage}) {

    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [dashTopData, setDashTopData] = useState({
        serviceCnt: 0, identityUserCnt: 0, totalAccess: 0, totalExpire:0
    }); //사용자 통계
    const [tokenChartData, setTokenChartData] = useState(null); //액세스토큰 24시간 그래프
    const [ServiceUsersChartdata, setServiceUsersChartdata] = useState(null); //서비스유저 통계

    const { selectedService } = useSelectedService();
    //서비스 아이디

    useEffect(() => {
        // fetchTotalUserData();
        // fetchToeknChartData();
        // fetchServiceUserChartData();
    }, []);

    useEffect(() => {
        if (selectedService) {
            fetchTotalUserData();
            fetchToeknChartData(selectedService.serviceId);
        }
    }, [selectedService]);

    // delay 초마다 데이터 fetching
    useInterval(() => {
        fetchToeknChartData();
        // fetchServiceUserChartData();
    }, 10 * 60 * 1000);


    // //사용자 통계 조회 API 
    const fetchTotalUserData = () => {

        const url = IAM_SERVER_DASHBOARD + "/service/statistics/"+selectedService.serviceId;
        axios.get(url)
            .then((res) => {
                setDashTopData(res.data.data);
            })
            .catch((e) => {
            })
            .finally(() => {
                setLoading(false);
            })
    }

    // 토큰 액세스 24시간 통계 조회 API 
    const fetchToeknChartData = async () => {
        const tokenUrl = IAM_SERVER_DASHBOARD + "/last24hours/service?serviceId="+selectedService.serviceId+"&actionType=OAAS0300";
        setTokenChartData(null);
        axios.get(tokenUrl)
            .then(res => {
                processToekenChartData(res.data.data);
            })
            .catch(err => {
            })
            .finally(() => {
                setLoading(false);
            })
    }

    // 액세스 발급 통계 조회 API Response Data 처리
    const processToekenChartData = (data) => {
        try {
            const labelArray = [];
            const countArray = [];
        for (const chartData of data) {
            // statDate에서 시각만 추출 ("2025-06-04T01:00:00.000+00:00" → "01:00")
            // ISO 형식이 아니라면 new Date()로 변환 후 getHours() 사용
            const date = new Date(chartData.id.statDate);
            const hour = date.getHours().toString().padStart(2, "0");
            labelArray.push(`${hour}:00`);
            countArray.push(chartData.cnt);
        }

            const graphData = {
                labels: labelArray.length === 0 ? [] : labelArray,
                datasets: [{
                    label: '액세스 토큰 통계',
                    data: countArray ?? [],
                    borderColor: 'rgb(99, 102, 241)',
                    backgroundColor: 'rgba(99, 102, 241, 0.1)',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    pointBackgroundColor: 'rgb(99, 102, 241)',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointHoverBackgroundColor: 'rgb(99, 102, 241)',
                    pointHoverBorderColor: '#fff',
                    pointHoverBorderWidth: 3,
                }]
            }

            setTokenChartData(graphData);
        } catch (e) {
        }
    }

    // 서비스 유저 통계 조회 API Response Data 처리
    const processServiceUsersChartData = (data) => {
        const labelArray = [];
        const countArray = [];
        for (const chartData of data) {
            labelArray.push(chartData.serviceId);
            countArray.push(chartData.userCount);
        }

        const graphData = {
            labels: labelArray.length === 0 ? [] : labelArray,
            datasets: [{
                label: '서비스 사용자 통계',
                data: countArray ?? [],
            }]
        }

        setServiceUsersChartdata(graphData);
    }

    // 그래프 options - 개선된 스타일
    const options = {
        responsive: true,
        maintainAspectRatio: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)',
                    drawBorder: false,
                },
                ticks: {
                    stepSize: 10,
                    padding: 10,
                    font: {
                        size: 12,
                    },
                    color: '#666',
                },
            },
            x: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
                ticks: {
                    padding: 10,
                    font: {
                        size: 11,
                    },
                    color: '#666',
                    maxRotation: 0,
                    minRotation: 0,
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: 12,
                titleColor: '#fff',
                titleFont: {
                    size: 13,
                    weight: 'bold',
                },
                bodyColor: '#fff',
                bodyFont: {
                    size: 12,
                },
                borderColor: 'rgba(255, 255, 255, 0.1)',
                borderWidth: 1,
                displayColors: false,
                callbacks: {
                    label: function(context) {
                        return '발급 수: ' + context.parsed.y + '건';
                    }
                }
            },
        },
    };

    return (
        <div className={styles.layoutWrapper}>
            <h3>대시보드</h3>
            <div className={styles.statCardWrapper}> 
                <StatCard
                  icon={<svg  aria-hidden="true" xmlns="http://www.w3.org/2000/svg"  fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 19h4a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-2m-2.236-4a3 3 0 1 0 0-4M3 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                  </svg>
                  }
                  title={'서비스 사용자 수'}
                  value={dashTopData.serviceUserCnt}
                ></StatCard>
                <StatCard
                  icon={<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" d="M4 4a2 2 0 1 0 0 4h16a2 2 0 1 0 0-4H4Zm0 6h16v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8Zm10.707 5.707a1 1 0 0 0-1.414-1.414l-.293.293V12a1 1 0 1 0-2 0v2.586l-.293-.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l2-2Z" clip-rule="evenodd"/>
                  </svg>
                  
                  }
                  title={'하루 발급 현황 (발급/만료)'}
                  value={`${dashTopData.totalAccess}/${dashTopData.totalExpire}`}
                ></StatCard> 
            </div>

            <div className={styles.chartContainer}>
                <div className={styles.chartCard}>
                    <div className={styles.chartHeader}>
                        <div className={styles.chartTitleWrapper}> 
                            <h3 className={styles.chartTitle + " innocode-typography--headline-md innocode-typography--semibold"}>액세스 발급 현황</h3>
                        </div> 
                    </div>
                    <div className={styles.chartContent}>
                        {tokenChartData === null ? (
                            <div className={styles.chartEmpty}>
                                <svg className={styles.emptyIcon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                </svg>
                                <p className={styles.emptyText}>데이터를 불러올 수 없습니다</p>
                            </div>
                        ) : (
                            <div className={styles.chartWrapper}>
                                <Line data={tokenChartData} options={options} style={{width: '100%', height: '100%'}}/>
                            </div>
                        )}
                    </div>
                </div>
            </div> 
        </div>
    )
}

export default Dashboard;